import { axiosService, ApiResponse } from '../axios';
import { getErrorObj } from '@/utils/handle-request-error';

/** Persistent dispatch tasks; status includes the final APS Outbox delivery result. */
export interface OrderDispatchTask {
  id: string;
  orderId: string;
  target: 10 | 20;
  operation: 10 | 20 | 30;
  status: 10 | 20 | 30 | 40 | 50;
  error?: string;
  /** Server decides whether a failed task is recoverable and blocks later work. */
  retryable?: boolean;
  blocking?: boolean;
  /** Uncertain MES operations require explicit external reconciliation before recovery. */
  resolvable?: boolean;
  itemIds: string[];
}
export async function listDispatchTasks(orderIds: string[]): Promise<OrderDispatchTask[]> {
  if (!orderIds.length) return [];
  const result: OrderDispatchTask[] = [];
  for (let offset = 0; offset < orderIds.length; offset += 200) {
    const res: ApiResponse<OrderDispatchTask[]> = await axiosService.post('integration/order-dispatch/list', {
      orderIds: orderIds.slice(offset, offset + 200)
    });
    if (res.code !== 0) throw getErrorObj(res.code);
    result.push(...res.data);
  }
  return result;
}
export async function retryDispatchTask(id: string): Promise<void> {
  const res: ApiResponse<unknown> = await axiosService.post('integration/order-dispatch/retry', { id });
  if (res.code !== 0) throw getErrorObj(res.code);
}

export async function resolveDispatchCancellation(id: string, note: string): Promise<void> {
  const res: ApiResponse<unknown> = await axiosService.post('integration/order-dispatch/resolve-cancel', {
    id, note, confirmed: true
  });
  if (res.code !== 0) throw getErrorObj(res.code);
}

export async function resolveDispatchCreation(id: string, note: string): Promise<void> {
  const res: ApiResponse<unknown> = await axiosService.post('integration/order-dispatch/resolve-create', {
    id, note, confirmed: true
  });
  if (res.code !== 0) throw getErrorObj(res.code);
}
